import Type from 'src/Type';
import config from 'src/utils/config';

import Node from '../Node';

import type Context from 'src/Context';
import type { Expression } from 'src/types';

export interface UpdateCompanyNodeT {
    $type: 'UpdateCompanyNode';
    id: Expression;
    data: Expression;
}

export default class UpdateCompanyNode extends Node<UpdateCompanyNodeT> {
    static TYPE = Type.Object(
        {
            key: 'id',
            label: 'Company._id',
            type: 'StringNode',
            suggestions: 'string',
        },
        { key: 'data', label: 'Data', type: 'ObjectNode' },
    );

    static uiConfig = {
        ...config.presets.tasker,
        description: "Update an existing Company's name and parentCompany",
    };

    static getDefault(): Expression {
        return {
            ...super.getDefault(),
            id: this.getDefaultFor('StringNode'),
            data: {
                ...this.getDefaultFor('ObjectNode'),
                value: {
                    name: this.getDefaultFor('StringNode'),
                    parentCompany: this.getDefaultFor('StringNode'),
                },
            },
        };
    }

    async execute(context: Context): Promise<void> {
        const id = await context.evaluateLog('id', this.expression.id);
        const data = await context.evaluateLog('data', this.expression.data);

        if (!data || typeof data !== 'object') throw new Error('Company must be an object');

        context.addTaskerAction({
            kind: 'updateCompany',
            company: id,
            data,
        });
    }
}
